module.exports = __webpack_public_path__ + "img/slack.a34c887f.svg";